import SelectableCard from 'components/selectable-card';
import React from 'react';
import { PET_TYPE } from '../constants';
import { useSubscriptionFunnel } from '../state';

const PetTypeSelector: React.FC = () => {
  const { petType, setPetType } = useSubscriptionFunnel();

  return (
    <div className="-mx-2 mt-4 flex">
      <div className="flex-1 px-2">
        <SelectableCard
          label={PET_TYPE.DOG}
          src="/images/futterabo/PetsDeli_FutterAbo_Pet_Dog_260x180px.jpeg"
          sizes="(min-width: 1024px) 296px, 50vw"
          selected={petType === PET_TYPE.DOG}
          onSelect={() => {
            setPetType(PET_TYPE.DOG);
          }}
        />
      </div>
      <div className="flex-1 px-2">
        <SelectableCard
          label={PET_TYPE.CAT}
          src="/images/futterabo/PetsDeli_FutterAbo_Pet_Cat_260x180px.jpeg"
          sizes="(min-width: 1024px) 296px, 50vw"
          selected={petType === PET_TYPE.CAT}
          onSelect={() => {
            setPetType(PET_TYPE.CAT);
          }}
        />
      </div>
    </div>
  );
};

export default PetTypeSelector;
